<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    
    <h2>嘉義縣農情調查(一期、二期、裡作)</h2>
    <div class="Info_Area">
      <b-container fluid>
        <b-row align-h="end">
          <b-col cols="auto" style="display: inline-flex;">
            <label style="margin-right: 0.5rem;">
              <label for="file" class="btn btn-success">匯入</label>
              <input
                @change="uploadFile"
                id="file"
                type="file"
                style="display: none;"
              />
            </label>
            <label style="margin-right: 0.5rem;">
              <a
                  href="https://agri-data.cyhg.gov.tw/Chiayi/uplode/112%e8%be%b2%e6%83%85%e8%aa%bf%e6%9f%a5-%e8%b3%87%e6%96%99%e5%8c%af%e5%85%a5%e7%af%84%e6%9c%ac.xlsx"
                  download="農情調查匯入範例.xlsx"
                >
                  <b-button>範本下載</b-button>
                </a>
            </label>
            <label>
              <b-button
              style="padding-right: 10px;"
              variant="info"
              @click="showPModal()"
              >品種管理</b-button>
            </label>
            </b-col>
        </b-row>
        <b-col cols="auto">
          <b-form inline>
            <b-form-select
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="yearselected"
              :options="yearlist"
              @change="TogetTown()"
            ></b-form-select>
            <b-form-select
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="townselected"
              :options="townlist"
              @change="getperiod()"
            ></b-form-select>
            <b-form-select
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="periodselected"
              :options="periodlist"
            ></b-form-select>
            <b-form-select
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="selected"
              :options="options"
            ></b-form-select>
            <b-button @click="getCropList()" variant="warning" class="btn-sm-block"
            >查詢</b-button>
          </b-form>
        </b-col>
        <div style="height:10px;"></div>
        <b-col cols="auto">
          <b-table 
            :items="priceanalysis.items"
            :fields="
            window.width <= 1024
              ? priceanalysis.fields_mobile
              : priceanalysis.fields
            "
            :per-page="perPage"
            :current-page="currentPage"
            :busy="isBusy"
            responsive="sm"
            striped
            bordered
            outlined
            hover
            head-variant="dark"
            >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(EDIT)="row">
              <b-button
                v-if="showmanage.edit" 
                variant="info" 
                class="btn-sm-block" 
                @click="showModal(row)">
                區段分布</b-button>
            </template>
            </b-table>
            <b-pagination
              v-show="totalRows > perPage"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="companyList"
              align="center"
              >
            </b-pagination>
        </b-col>
      </b-container>
      <template>
        <b-modal v-model="Pshow" title="品種管理" size="lg" id="v-center-modal" hide-footer scrollable centered >
          <table class="table table-striped table-bordered table-hover">
            <thead class="thead-dark">
              <tr>
                <th scope="col">作物</th>
                <th scope="col">品種</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody v-for="(row,index) in this.varietylist" :key="index">
              
                <td style="vertical-align: middle">{{row.C_NAME}}</td>
                <td style="vertical-align: middle">{{row.V_NAME}}</td>
                <td><b-button
                  v-if="showmanage.edit" 
                  variant="danger" 
                  class="btn-sm-block" 
                  style="width: max-content;"
                  @click="DeleteData(row)"
                  >
                  刪除</b-button></td>
            </tbody>
            <td colspan="2">
              <div>
                <v-select
                v-model="varietycropselected"
                :options="varietycroplist"
                style="width:15rem;margin-right: 0.5rem; float:left"
                @input="changevname"
              ></v-select>
              <v-select 
                v-model="varietyvnameselected"
                :options="varietyvnamelist"
                style="width:20rem;margin-right: 0.5rem; float:left"
              ></v-select>
              </div>
              
            </td>
            <td>
                <b-button
                  v-if="showmanage.edit" 
                  variant="info" 
                  class="btn-sm-block" 
                  @click="InsertVariety()">
                  新增</b-button>
            </td>
          </table>
        </b-modal>
      </template>
      <template>
        <b-modal size="lg" v-model="show" title="區段分布"  hide-footer scrollable centered>
          <div class="sectdata">
            <table class="table table-striped table-bordered table-hover">
            <tbody>
              <tr>
                <th scope="row">年度:</th>
                <td>{{this.yearselected}}</td>
              </tr>
              <tr>
                <td>鄉鎮:</td>
                <td>{{this.selectedData.TOWN}}</td>
              </tr>
              <tr>
                <td>期別:</td>
                <td>{{this.selectedData.PERIOD}}</td>
              </tr>
              <tr>
                <td>作物:</td>
                <td>{{this.selectedData.CROP}}</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-bordered table-hover">
            <thead class="thead-dark">
              <tr>
                <th scope="col">區段</th>
                <th scope="col">小區</th>
                <th scope="col">種植面積</th>
                <th scope="col">間作面積</th>
                <th scope="col">前後期作面積</th>
                <th scope="col">未達結實面積</th>
              </tr>
            </thead>
            <tbody v-for="(row,index) in this.sectdata" :key="index">
              <tr>
                <td>{{row.SECT_NAME}}</td>
                <td>{{row.SECT_SUB}}</td>
                <td>{{row.AREA_P}}</td>
                <td>{{row.AREA_I}}</td>
                <td>{{row.AREA_O}}</td>
                <td>{{row.AREA_NH}}</td>
              </tr>
            </tbody>
          </table>
          </div>
          
      </b-modal>  
      </template>
    </div>
  </b-container>
</template>
<script>
//import ANIMALCODELIST from "@/data/ANIMAL_CODE_LIST.json";
// import datepicker from "@/components/Datepicker.vue";


export default {
  data() {
    return {
      //農情調查變數宣告:
      yearlist: [],
      townlist: ["請選擇鄉鎮"],
      periodlist: ["請選擇期別"],
      yearselected:"請選擇年度",
      townselected:"請選擇鄉鎮",
      periodselected:"請選擇期別",
      croplist:[],
      isALL:false,
      perPage: 10,
      currentPage: 1,
      filterSearch: null,
      selection: [],
      totalRows: 1,
      isBusy: false,
      aa:[],
      sectdata:[],
      selectedData:[],
      varietylist:[],
      varietycroplist:[],
      varietycropselected:"請選擇農情作物",
      varietyvnamelist:[],
      varietyvnameselected:"請選擇市場作物",
      show: false,
      Pshow:false,
      // timepicker: {
      //   //minvalue: taiwanMinDate.join("-"),
      //   //maxvalue: taiwanMaxDate.join("-"),
      //   max: maxDate
      //     .toLocaleString()
      //     .split(" ")[0]
      //     .split("/")
      //     .join("-"),
      // },
      selected: 1 ,
      options:[
        { value: 1, text: '全部'}, 
        { value: 2, text: '主要作物品種面積調查'}
      ],
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "農情調查資料維護",
          active: true,
        },
      ],
      window: {
        width: 1024,
        height: 0,
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      priceanalysis: {
        fields: [
          {
            key: "A_YEAR",
            label: "年度",
            visible: true,
          },
          {
            key: "PERIOD",
            label: "期別",
            visible: true,
          },
          {
            key: "TOWN",
            label: "鄉鎮",
            visible: true,
          },
          {
            key: "CROP",
            label: "農情作物",
            visible: true,
          },
          {
            key: "AREA_P",
            label: "種植面積",
            visible: true,
          },
          {
            key: "AREA_I",
            label: "間作面積",
            visible: true,
          },
          {
            key: "AREA_O",
            label: "前後期作面積",
            visible: true,
          },
          {
            key: "AREA_NH",
            label: "未達結實面積",
            visible: true,
          },
          {
            key: "EDIT",
            label: "區段分布",
            visible: true,
          },
        ],
        fields_mobile: [
          {
            key: "TOWN",
            label: "鄉鎮",
            visible: true,
          },
          {
            key: "CROP",
            label: "農情作物",
            visible: true,
          },
          {
            key: "AREA_P",
            label: "種植面積",
            visible: true,
          },
          {
            key: "EDIT",
            label: "區段分布",
            visible: true,
          },
        ],
        items: [],
        additem: {},
      },
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      //DeteleVarietyShip
      apiGetYearList: (data) =>
        this.userRequest.post("API/Default/AgriSurveyPeriodYearList", data),
      apiGetTownList: (data) =>
        this.userRequest.post("API/Default/ASPTownList", data),
      apiGetPeriodList: (data) =>
        this.userRequest.post("API/Default/ASPPeriodList", data),
      apiGetCropList: (data) =>
        this.userRequest.post("API/Default/ASPcropList", data),
      apiGetSectData: (data) =>
        this.userRequest.post("API/Default/GetSectDataLists", data),
      apiGetInitData: (data) =>
        this.userRequest.post("API/Default/GetInitData", data),
      apiGetVarietyList: (data) =>
        this.userRequest.post("API/Default/GetVarietyList", data),
      apiGetVarietyCrop: (data) =>
        this.userRequest.post("API/Default/ToGetVarietyCrop", data),
      apiInsertVarietyShip: (data) =>
        this.userRequest.post("API/Default/InsertVarietyShip", data),
      apiDeleteVarietyShip: (data) =>
        this.userRequest.post("API/Default/DeleteVarietyShip", data),
    };
  },
  created() {
    this.checkLogin();
  },
  mounted() {
    this.FunctionToken(this.togetYear,{});
    this.FunctionToken(this.getInitData,{});
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000014",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000015",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000016",
        fun: this.checkByPJIDedit,
      });
    },
    checkallpermission() {
      if (this.showmanage.show || this.showmanage.add || this.showmanage.edit) {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    
    init() {
      //this.createoptions();
      //this.getAnimalManagementList();
      this.settotalRows();
      // this.priceanalysis.items = [...this.priceanalysis.allitems]
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    //
    getInitData(data){
      //console.log("getInitData method called with init()");
      this.apiGetInitData(data)
      .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items=[];
            let jsonData = JSON.parse(json.Data);
            this.priceanalysis.items=jsonData;
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //取得年度清單
    togetYear(data){
      this.apiGetYearList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.yearselected=jsonData[0].A_YEAR;
            this.yearlist=[];
            //this.aa=jsonData;
            for(let i = 0; i < jsonData.length ; i++){
                this.yearlist.push(jsonData[i].A_YEAR);
            }
          }
          this.TogetTown();
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //取得年度鄉鎮清單
    TogetTown(){
      //console.log("TogetTown method called with this.yearselected:",this.yearselected);
      this.FunctionToken(this.getTownList,{A_YEAR: this.yearselected});
    },
    getTownList(data){
      this.apiGetTownList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.townselected="請選擇鄉鎮";
            this.townlist=["請選擇鄉鎮"];
            //this.aa=jsonData;
            for(let i = 0; i < jsonData.length ; i++){
              this.townlist.push(jsonData[i].Town);
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getperiod(){
      console.log("getperiod method called with this.townselected: ",this.townselected);
      this.FunctionToken(this.getPeriodList,{
        A_YEAR: this.yearselected,
        Town: this.townselected,
      });
    },
    getPeriodList(data){
      console.log("getPeriodList method called with this.townselected: ");
      this.apiGetPeriodList(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.periodselected="請選擇期別";
            this.periodlist=["請選擇期別"];
            //this.aa=jsonData;
            for(let i = 0; i < jsonData.length ; i++){
              this.periodlist.push(jsonData[i].period);
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //農情查詢取得清單
    getCropList(){
      console.log("getCropList method called 查詢button");
      this.isBusy=true;
      this.FunctionToken(this.ToGetCropList,{
        A_YEAR: this.yearselected,
        Town: this.townselected=="請選擇鄉鎮" ? ""  : this.townselected,
        period: this.periodselected=="請選擇期別" ? "" : this.periodselected,
        isALL: this.selected==1 ? "false" : "true",
      });
    },
    ToGetCropList(data){
      console.log("ToGetCropList method called with getCropList()");
      this.apiGetCropList(data)
      .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items=[];
            let jsonData = JSON.parse(json.Data);
            this.priceanalysis.items=jsonData;
            this.isBusy = false;
            // this.totalRows = this.priceanalysis.items.length;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //區段分布資料顯示
    showModal(row) {
      console.log(row);
      this.show = true;
      this.sectdata=[];
      this.selectedData = row.item;
      this.FunctionToken(this.getsectdata,{
        A_YEAR: this.selectedData.A_YEAR,
        ANA_TOWN_ID: this.selectedData.ANA_TOWN_ID,
        PERIOD: this.selectedData.PERIOD,
        ANA_C_ID: this.selectedData.ANA_C_ID,
      });
    },
    getsectdata(data){
      console.log("getsectdata method called with showModal");
      this.apiGetSectData(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.sectdata=[];
            let jsonData = JSON.parse(json.Data);
            this.sectdata= jsonData;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //品種管理顯示
    showPModal(){
      console.log("showPModal method called with 品種管理");
      this.Pshow = true;
      this.FunctionToken(this.getvarietylist,{});
      this.FunctionToken(this.getvarietycrop,{});
    },
    //取得品種管理清單
    getvarietylist(data){
      console.log("getvarietylist method called with showPModal()");
      this.varietylist =[],
      this.apiGetVarietyList(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.varietylist= jsonData;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //取得品種管理選單
    getvarietycrop(data){
      console.log("getvarietycrop method called with showPModal()");
      if(!data.C_NAME){
      this.varietycroplist=[];
      this.varietycroplist =["請選擇農情作物"];
      this.varietycropselected="請選擇農情作物";
      this.varietyvnameselected="請選擇市場作物"
      this.apiGetVarietyCrop(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            for(let i = 0; i < jsonData.length ; i++){
              this.varietycroplist.push(jsonData[i].C_NAME);
            }
          }
          this.varietyvnamelist=[];
        })
        .catch((err) => {
          console.warn(err);
        });
      }
      else{
        this.varietyvnamelist=[];
        this.varietyvnamelist=["請選擇市場作物"];
        this.varietyvnameselected="請選擇市場作物";
        this.apiGetVarietyCrop(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            for(let i = 0; i < jsonData.length ; i++){
              this.varietyvnamelist.push(jsonData[i].V_NAME);
            }
            this.varietyvnameselected=jsonData[0].V_NAME;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
      }
      
    },
    //選取農情產品後尋找對應市場作物
    changevname(){
      console.log("changevname method called with v-");
      this.FunctionToken(this.getvarietycrop,{C_NAME:this.varietycropselected});
    },
    InsertVariety(){
      console.log("InsertVariety method called with 新增button");
      this.FunctionToken(this.InsertDatatoVariety,{
        C_NAME:this.varietycropselected,
        V_NAME:this.varietyvnameselected
      });
    },
    //新增品種管理
    InsertDatatoVariety(data){
      console.log("InsertDatatoVariety method called InsertVariety");
      this.apiInsertVarietyShip(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("新增成功");
            
            this.FunctionToken(this.getvarietylist,{});
            this.FunctionToken(this.getvarietycrop,{});
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //刪除品種管理
    DeleteData(row){
      console.log("DeleteData Method called with 刪除button");
      this.FunctionToken(this.DeleteVarietyShip,{C_NAME: row.C_NAME});
    },
    DeleteVarietyShip(data){
      console.log("DeleteVarietyShip method called DeleteData");
      this.apiDeleteVarietyShip(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("刪除成功");
            
            this.FunctionToken(this.getvarietylist,{});
            this.FunctionToken(this.getvarietycrop,{});
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //上傳EXCEL
    uploadFile(e) {
      const file = e.target.files[0];
      console.log(file);
      alert("上傳中...資料龐大時需較多時間...");
      let formdata = new FormData();
      formdata.append("Files", file);
      this.userRequest
        .post("API/Default/AgriSurveyPeriodUploadExcel", formdata)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            console.log(jsonData);
            alert("上傳成功");
            window.location.reload();
          } else {
            console.warn("上傳失敗");
            alert("上傳失敗");
            window.location.reload();
          }
        });
    },
    settotalRows() {
      this.totalRows = this.priceanalysis.items.length;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  watch: {
    "priceanalysis.items"() {
      this.settotalRows();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
  components: {
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
.picker {
  width: 200px;
}
.sectdata th,td{
  font-size: 2 rem;
}
#v-center-modal{
  width: 600px !important;
}

</style>
